import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSearchNoResults = function SvgSearchNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v128c-35.299 0-64-28.701-64-64s28.591-64 64-64Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.041 116c9.965 0 18.042-8.077 18.042-18.041 0-9.965-8.077-18.042-18.041-18.042C47.076 79.917 39 87.994 39 97.958 39 107.924 47.078 116 57.041 116Z",
    stroke: "#0C1733",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.083 56.463V42.03c-2.706-2.707-8.119-2.707-10.825 0l-5.412 14.433-5.413 5.412-10.825 25.258M103.95 116c9.964 0 18.041-8.077 18.041-18.041 0-9.965-8.077-18.042-18.041-18.042-9.965 0-18.042 8.077-18.042 18.041 0 9.965 8.078 18.042 18.042 18.042Z",
    stroke: "#0C1733",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.908 56.463V42.246c2.706-2.706 8.119-2.706 10.825 0l5.412 14.217 5.413 5.412 10.825 25.258M66.062 70.896c0-3.987 6.46-7.216 14.434-7.216 7.974 0 14.433 3.229 14.433 7.216M75.083 97.959V64.203M85.908 97.959V64.203M46.217 97.959c0-5.972 4.853-10.826 10.825-10.826M93.125 97.959c0-5.972 4.853-10.826 10.825-10.826",
    stroke: "#0C1733",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Memo = /*#__PURE__*/memo(SvgSearchNoResults);

export { Memo as default };
//# sourceMappingURL=search-no-results.svg.js.map
